var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.863,
    height: 24,
    viewBox: "0 0 19.863 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;fill-rule:evenodd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M19.632,19.263A1.609,1.609,0,0,1,18.216,20H13.893a3.974,3.974,0,1,1-7.948,0H1.624a1.609,1.609,0,0,1-1.416-.737,1.634,1.634,0,0,1-.022-1.6l2.781-4.922V7a6.953,6.953,0,1,1,13.9,0v5.735l2.756,4.876A1.658,1.658,0,0,1,19.632,19.263ZM9.918,22a2,2,0,0,0,1.988-2H7.931A2,2,0,0,0,9.918,22Zm5.1-8.505c-.01-.018-.009-.037-.018-.055a.91.91,0,0,1-.062-.189,1.036,1.036,0,0,1-.039-.2c0-.02-.011-.036-.011-.056V7A4.966,4.966,0,1,0,4.954,7v6a.559.559,0,0,1-.012.056.9.9,0,0,1-.039.2.939.939,0,0,1-.062.19c-.008.017-.008.036-.017.054L2.278,18H17.563Z",
    transform: "translate(0.013)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.d743ed27f5aae9d249056db3a4bb2e6f.svg";
export { ForwardRef as ReactComponent };